import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { getFirstAccessibleRoute } from '../../../utils/navigationHelper';
import TopNav from '../../../components/TopNav';
import OfflineNotificationBar from '../../../components/OfflineNotificationBar';
import POSCategorySideNav from './POSCategorySideNav';

const POSLayout = ({ 
  children,
  categories,
  selectedCategory,
  onSelectCategory,
}) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [notificationVisible, setNotificationVisible] = useState(false);
  const navigate = useNavigate();
  const { user, role, modulePermissions } = useAuth();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleSwitchToMainView = async () => {
    const route = await getFirstAccessibleRoute(
      user?.id || user?.email,
      role,
      modulePermissions
    );
    navigate(route);
  };

  useEffect(() => {
    const handleNotificationVisibility = (event) => {
      setNotificationVisible(event.detail.visible);
    };

    window.addEventListener('offlineNotificationVisibility', handleNotificationVisibility);
    return () => {
      window.removeEventListener('offlineNotificationVisibility', handleNotificationVisibility);
    };
  }, []);

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', position: 'relative' }}>
      {/* TopNav wrapper - override default sidebar positioning */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: (theme) => theme.zIndex.drawer + 1,
          '& .MuiAppBar-root': {
            ml: 0,
            width: '100%',
          },
        }}
      >
        <TopNav onMenuClick={handleDrawerToggle} />
      </Box>
      <OfflineNotificationBar />
      <POSCategorySideNav
        mobileOpen={mobileOpen}
        onMobileClose={handleDrawerToggle}
        onSwitchToMainView={handleSwitchToMainView}
        categories={categories}
        selectedCategory={selectedCategory}
        onSelectCategory={onSelectCategory}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          mt: notificationVisible ? { xs: '92px', sm: '86px' } : '64px',
          backgroundColor: '#f8f9fa',
          height: notificationVisible ? { xs: 'calc(100vh - 92px)', sm: 'calc(100vh - 86px)' } : 'calc(100vh - 64px)',
          overflow: 'hidden',
          p: 0,
          transition: 'margin-top 0.3s ease-in-out, height 0.3s ease-in-out',
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default POSLayout;
